// export const baseURL = 'http://192.168.2.212:16924'
// export const sourceURL = 'http://192.168.2.212'
// export const pbSourceURL = 'http://192.168.2.212'

export const baseURL = "https://hypadinterface.djplus.cn";
export const sourceURL = "https://hypadinterface.djplus.cn";
export const pbSourceURL = "https://hyinterface.djplus.cn"; // 洪雅智慧党建模块
export const prevSourseURL = "https://hypad.djplus.cn";

// export const baseURL = "http://192.168.2.236:7001";
// export const sourceURL = "http://192.168.2.236:7001";
// export const pbSourceURL = "http://192.168.2.236:7001"; // 洪雅智慧党建模块
// export const prevSourseURL = "https://hypad.djplus.cn";
